<div class="modal-header">
  <h4 class="modal-title">Select the breed</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body p-0">
  <ul class="list-group">
    <li
      *ngFor="let breed of breeds | slice: (page-1) * pageSize : page * pageSize; index as i; let first=first; let last=last"
      class="list-group-item"
      [ngClass]="{ 'border-top-0': first, 'border-bottom-0': last, 'rounded-0': first || last }">
      <button
        class="btn btn-link text-start"
        (click)="activeModal.close(breed)">
        {{ breed }}
      </button>
    </li>
  </ul>
</div>
<div class="modal-footer">
  <ngb-pagination
    class="text-center"
    [collectionSize]="breeds.length"
    [(page)]="page"
    [maxSize]="5"
    [pageSize]="pageSize"
    [rotate]="true"
    [ellipses]="false"
    [boundaryLinks]="true">
  </ngb-pagination>
</div>

